import * as actions from "../actions";
import axios from "axios";
import { readCookie } from "./translations";
import { store } from "../../store";

import permissionsJson from "../../auth/config/permissions.json";
export const permissionsFile = permissionsJson;

export const authenticationMode = localStorage.getItem("authenticationMode") === "true";

export const useProductionSettings = localStorage.getItem("permissionsUseProductionSettings");

const initialState = {
  permissions: {},
  allPermissions: null,
  toBeAppliedPermissions: {},
  isProductionMode: useProductionSettings ? useProductionSettings === "true" : import.meta.env.MODE === "production",
};

export const getPermissionsFile = () => {
  return new Promise((resolve, reject) => {
    let permissions = localStorage.getItem("backoffice_permissions");
    if (permissions) {
      permissions = JSON.parse(permissions);
    }
    const cookie = readCookie("backoffice_permissions");

    if (permissions?.metadata?.timestamp === parseInt(cookie)) {
      if (authenticationMode) {
        getUnappliedPermissions(permissions).then(({ permissions, toBeAppliedPermissions }) => {
          resolve({ permissions, toBeAppliedPermissions });
        });
      } else {
        resolve({ permissions, toBeAppliedPermissions: {} });
      }
      return;
    }

    permissions = { permissions: permissionsFile.permissions };

    let permissionsUrl = import.meta.env.VITE_AZURE_STORAGE + "backoffice/permissions/permissions.json";

    if (!initialState.isProductionMode) {
      let devIdentifier = readCookie("dev_identifier") ?? "DEV";
      permissionsUrl =
        import.meta.env.VITE_AZURE_STORAGE + "backoffice/permissions/" + devIdentifier + "/permissions.json";
    }

    axios
      .get(permissionsUrl + "?" + Date.now())
      .then((response) => {
        permissions.permissions = { ...permissions.permissions, ...response.data.permissions };
        permissions.metadata = response.data.metadata;
      })
      .catch((err) => {
        permissions.permissions = { ...permissions.permissions };
      })
      .finally(() => {
        if (authenticationMode) {
          getUnappliedPermissions(permissions).then(({ permissions, toBeAppliedPermissions }) => {
            localStorage.setItem("backoffice_permissions", JSON.stringify(permissions));
            resolve({ permissions, toBeAppliedPermissions });
          });
        } else {
          localStorage.setItem("backoffice_permissions", JSON.stringify(permissions));
          resolve({ permissions, toBeAppliedPermissions: {} });
        }
      });
  });
};

const getUnappliedPermissions = (permissions) => {
  const data = [{ field: "applied", operator: "=", value: 0 }];
  return new Promise((resolve) => {
    axios
      .create()
      .post("core/backofficePermission/search?per_page=9999999&page=1", data)

      .then((response) => {
        const toBeAppliedPermissions = {};
        response.data.data.data.forEach((permissionRow) => {
          permissions.permissions[permissionRow.permission_key] = permissionRow.value;
          toBeAppliedPermissions[permissionRow.permission_key] = permissionRow.value;
        });

        resolve({ permissions, toBeAppliedPermissions });
      })
      .catch((err) => {
        resolve({ permissions, toBeAppliedPermissions: {} });
      });
  });
};

export const loadPermissions = () => {
  if (authenticationMode) {
    axios
      .create()
      .get("core/permissions?per_page=1000000&withTrashed=1")
      .then((response) => {
        const allPermissions = {};
        response.data.data.data.forEach((permission) => (allPermissions[permission.name] = permission));
        store.dispatch({ type: actions.SET_ALL_PERMISSIONS, allPermissions: allPermissions });
      });
  }
  getPermissionsFile().then(({ permissions, toBeAppliedPermissions }) => {
    store.dispatch({
      type: actions.SET_PERMISSIONS,
      permissions: permissions,
      toBeAppliedPermissions: toBeAppliedPermissions,
    });
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //USER ACTIONS
    case actions.SET_PERMISSIONS:
      window.backofficePermissions = action.permissions.permissions;

      return {
        ...state,
        permissions: action.permissions.permissions,
        toBeAppliedPermissions: action.toBeAppliedPermissions,
      };
    case actions.SET_ALL_PERMISSIONS:
      window.allPermissions = action.allPermissions;
      return { ...state, allPermissions: action.allPermissions };
    default:
      return state;
  }
};

export default reducer;
